// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__2pq_s","navigationElement":"styles_navigationElement__3Nuaw"};